export class DisMonthModel{
    id:number;
    monthId:number;
    month:string;
    days:number;
    daysExcluded:number;

    constructor(){}
}